import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@app/core/services';
import { environment } from '@env/environment';
import { catchError, from, NEVER, switchMap, throwError } from 'rxjs';

function isExperienceOrApiRequest(url: string): boolean {
  const bases = [environment.integrationPortalApi.url, environment.experienceApi.url].filter((u) => u?.length);
  return bases.some((base) => url.startsWith(base));
}

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  if (isExperienceOrApiRequest(req.url)) {
    const authService = inject(AuthService);
    const authToken = authService.getApiToken();

    if (authToken) {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${authToken}`),
      });

      return next(authReq).pipe(
        catchError((error) => {
          if (error?.status === 401) {
            return from(authService.fetchAuthToken()).pipe(
              switchMap((redirected) => {
                if (redirected) {
                  return NEVER;
                }
                const newToken = authService.getApiToken();
                const retryReq = newToken
                  ? req.clone({
                      headers: req.headers.set('Authorization', `Bearer ${newToken}`),
                    })
                  : req;
                return next(retryReq);
              }),
              catchError((err) => throwError(() => err))
            );
          }
          return throwError(() => error);
        })
      );
    }
  }

  return next(req);
};

